/** jQuery JavaScript for global functionality **/
(function (global, $) {

    moment.locale('nl');

    /** Close a success alert automaticly after a specified time */
    global.autoCloseSuccessAlert = function (delay) {
        window.setTimeout(function () { $(".alert-success").fadeOut(); }, delay);
    }

    /** Close an info alert automaticly after a specified time */
    global.autoCloseInfoAlert = function (delay) {
        window.setTimeout(function () { $(".alert-info").fadeOut(); }, delay);
    }

    /** Close a warning alert automaticly after a specified time */
    global.autoCloseWarningAlert = function (delay) {
        window.setTimeout(function () { $(".alert-warning").fadeOut(); }, delay);
    }

    /** Enable popover */
    global.enablePopOver = function () {
        $('[data-bs-toggle="popover"]').popover();
    };

    /**
     *
     * @param {any} alertContainer the alert container to use for the alert HTML
     * @param {any} message the message to use
     * @param {any} autoCloseSuccess flag indicating whether to auto close the alert if it is a success message
     * @param {any} showProgressIndicator flag indicating whether to show a progress indicator in the message
     */
    global.ShowSuccessAlert = function (alertContainer, message, autoCloseSuccess = true, showProgressIndicator = false) {
        return global.ShowAlert(true, alertContainer, message, undefined, undefined, autoCloseSuccess, showProgressIndicator);
    };

    /**
     *
     * @param {any} alertContainer the alert container to use for the alert HTML
     * @param {any} message the message to use
     * @param {any} autoCloseSuccess flag indicating whether to auto close the alert if it is a success message
     * @param {any} showProgressIndicator flag indicating whether to show a progress indicator in the message
     */
    global.ShowInfoAlert = function (alertContainer, message, autoCloseSuccess = true, showProgressIndicator = false) {
        return global.ShowAlert(undefined, alertContainer, undefined, message, undefined, autoCloseSuccess, showProgressIndicator);
    };

    /**
     *
     * @param {any} alertContainer the alert container to use for the alert HTML
     * @param {any} message the message to use
     * @param {any} autoCloseSuccess flag indicating whether to auto close the alert if it is a success message
     * @param {any} showProgressIndicator flag indicating whether to show a progress indicator in the message
     */
    global.ShowDangerAlert = function (alertContainer, message, autoCloseSuccess = true, showProgressIndicator = false) {
        return global.ShowAlert(false, alertContainer, undefined, undefined, message, autoCloseSuccess, showProgressIndicator);
    };

    /**
     * Show an alert message in the top region of the viewport
     * @param {any} success flag indicating if it's a success of danger message
     * @param {any} alertContainer the alert container to use for the alert HTML
     * @param {any} successMessage the success message to use
     * @param {any} infoMessage the info message to use
     * @param {any} dangerMessage the danger message to use
     * @param {any} autoCloseSuccess flag indicating whether to auto close the alert if it is a success message
     * @param {any} showProgressIndicator flag indicating whether to show a progress indicator in the message
     */
    global.ShowAlert = function (success, alertContainer, successMessage, infoMessage, dangerMessage, autoCloseSuccess = true, showProgressIndicator = false) {
        var container = $(alertContainer);
        // retrieve template
        var alert = $("#alert-template").text();
        // create a unique id for the alert
        var alertId = global.CreateUUIDv4();
        alert = global.TemplateReplace(alert, "alertId", alertId);
        // replace values in the template
        if (success) {
            alert = global.TemplateReplace(alert, "alertType", "success");
            alert = global.TemplateReplace(alert, "alertMessage", successMessage);
        } if (success === undefined) {
            alert = global.TemplateReplace(alert, "alertType", "info");
            alert = global.TemplateReplace(alert, "alertMessage", infoMessage);
        } else {
            alert = global.TemplateReplace(alert, "alertType", "danger");
            alert = global.TemplateReplace(alert, "alertMessage", dangerMessage);
        }

        // append alert html to container to display it
        container.prepend(alert).alert();

        // possibly show progress indicator
        if (showProgressIndicator) {
            var progressIndicator = container.find('#progressIndicator');
            global.progressInterval = progressIndicatorText(progressIndicator);
        }

        // show the alert
        container.toggleClass('d-none');
        container.find(`#${alertId}`).on('closed.bs.alert', () => {
            // hide the alert
            container.toggleClass('d-none');
        })

        if ((success || success === undefined) && autoCloseSuccess) {
            // close alert after 3 seconds
            window.setTimeout(() => {
                container.find(`#${alertId}`).alert('close');
            }, 3000);
        }
        return container.find(`#${alertId}`);
    }

    /**
     * Close an alert
     * @param {any} alertContainer the alert container
     */
    global.CloseAlert = function (alertContainer) {
        if (global.progressInterval) {
            window.clearInterval(global.progressInterval);
            global.progressInterval = undefined;
        }

        if (!alertContainer)
            return;

        alertContainer.alert('close');
    }

    /**
     * Show a progress indicator in the form of three repeating dots as a suffix of the message
     * @param {any} alertContainerId id of the alert container
     */
    global.ShowProgressIndicator = function (alertContainerId) {
        var container = $(alertContainerId);
        var progressIndicator = container.find('#progressIndicator');
        if (progressIndicator.length == 0)
            return;
        global.progressInterval = progressIndicatorText(progressIndicator);
    }

    /**
     * Close a progress indicator
     * @param {any} alertContainerId id of the alert container
     */
    global.ClearProgressIndicator = function (alertContainerId) {
        var container = $(alertContainerId);
        var progressIndicator = container.find('#progressIndicator');
        if (progressIndicator.length == 0)
            return;
        window.clearInterval(global.progressInterval);
        progressIndicator.text('');
        global.progressInterval = undefined;
    }

    /**
    * This function inserts a value in a template using a regex replace
    * @param {string} template the template in which one or more values should be inserted
    * @param {string} key the key of the value that should be inserted into the template
    * @param {string} value the value to insert into the template
    * @returns {string} The template after replacing the values
    */
    global.TemplateReplace = function (template, key, value) {
        return template.replace(new RegExp(`{{${key}}}`, "gi"), value);
    }

    /* Initializes modal dialog */
    global.initModalDialog = function (callback) {
        $("#modalcontainer").on("show.bs.modal", function (e) {
            if ($(e.relatedTarget).attr("href")) {
                $("#modalcontainer .modal-content").html("");

                $("#modalcontainer .modal-content").load($(e.relatedTarget).attr("href"), null, function () {
                    $.validator.unobtrusive.parse($("FORM"));
                    if (callback)
                        callback();
                });
            }
            else {
                $.validator.unobtrusive.parse($("FORM"));
            }
        });

        /** Change event handler for option Alles/vanaf. When vanaf is chosen an input field is shown */
        $(document).on("change", "input[name='SyncAll']", function (e) {
            switch ($(this).val()) {
                case 'True':
                    $("#synchronizefrom").addClass('d-none');
                    break;
                case 'False':
                    $("#synchronizefrom").removeClass('d-none');
                    break;
            }
        });
    }

    global.onModalSuccess = function (context) {
        if (context.success === true) {
            $("#modalcontainer").modal("hide");

            if (context.gridId != null) {
                global.refreshTable(context.gridId);
            }
            if (context.gridIds != null) {
                context.gridIds.split(',').forEach(id => global.refreshTable(id));
            }

            var url = '';
            if (context.area != null)
                url += `/${context.area}`;
            if (context.controller != null)
                url += `/${context.controller}`;
            if (context.controllerAction != null)
                url += `/${context.controllerAction}`;

            if (url !== '')
                window.location.replace(url);
        }
    };

    global.refreshTable = function (gridId) {
        if (gridId != null) {
            let element = $("#" + gridId);
            if (element.hasClass('dataTable')) {
                element.DataTable().ajax.reload();
            }
            else {
                var source = element.data("source");
                if (source !== null && source !== undefined) {
                    element.load(source);
                }
            }
        }
    }
    global.onSubmit = function (callback) {
        if (callback)
            callback();
    };

    global.onFailure = function (context) {
        global.ShowAlert(context?.success ?? false, "#alertscontainer", context?.infoMessage, null, context?.errorMessage);
    };

    global.DisableButton = function (button) {
        button.prop('disabled', true);
    }

    /* Enable a button */
    global.EnableButton = function (button) {
        button.prop('disabled', false);
    }

    /* Shows a spinner inside a button*/
    global.ShowButtonSpinner = function (button) {
        var spinner = button.find('span');
        spinner.show();
    }

    /* Hides a spinner inside a button */
    global.HideButtonSpinner = function (button) {
        var spinner = button.find('span');
        spinner.hide();
    }

    /** Initialise of date masks in popups */
    global.initMasks = function () {
        $(document).ready(function () {
            $.applyDataMask();
        });
    }

    /** Rebind jquery validators */
    global.rebindValidators = function () {
        $form = $("FORM");
        $form.unbind();
        $form.data("validator", null);
        $.validator.unobtrusive.parse($form);
        $form.validate($form.data("unobtrusiveValidation").options);
    }

    /* Create a version 4 UUID */
    global.CreateUUIDv4 = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    global.initChunckedDropzone = function (name, options) {
        var _options = {
            init: function () {
                global.dropzone = this;
            },
            url: "/ChunkedUpload/UploadChunk",
            maxFiles: 1,
            addRemoveLinks: true,
            dictDefaultMessage: "Drop hier uw bestand om het te uploaden",
            dictResponseError: "Er is iets fout gegaan bij het uploaden van het bestand",
            dictCancelUpload: "Uploaden anuleren",
            dictRemoveFile: "Verwijderen",

            createImageThumbnails: false,
            parallelChunkUploads: 1,
            chunking: true,
            forceChunking: true,
            retryChunks: true,

            params: function (files, xhr, chunk) {
                if (chunk) {
                    return {
                        Key: chunk.file.upload.uuid,
                        Filename: chunk.file.name,
                        TotalFileSize: chunk.file.size,
                        ChunkSize: this.options.chunkSize,
                        ChunkCount: chunk.file.upload.totalChunkCount,
                        ChunkIndex: chunk.index,
                        CurrentChunkSize: chunk.dataBlock.data.size
                    };
                }
            }
        }

        if (options) {
            _options = $.extend(_options, options);
        }

        var element = $(name).dropzone(_options);

        if (options.addedFile)
            global.dropzone.on("addedfile", options.addedFile);

        return element;
    }

    var progressIndicatorText = function (progressIndicator) {
        const dot = '.';
        var i = 1;
        return window.setInterval(() => {
            var numberOfDots = i % 4;
            progressIndicator.text(dot.repeat(numberOfDots));
            i++;
        }, 500);
    }

}(window.global = window.global || {}, jQuery));

/* validate date in the format dd-MM-yyyy */
jQuery.validator.addMethod("customdate", function (value, element, params) {

    let val = $(element).val();
    if (val == "")
        return true;

    let compare = moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY');
    if (value == compare)
        return true;

    return false;
}, "Ongeldige datum.");
